var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/video-service-question-point.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-ec846f3a!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/video-service-question-point.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VideoServiceQuestionPoint.vue
// module id = 1360
// module chunks = 1